import React, { ChangeEvent } from 'react';
import { useRecoilState } from 'recoil';
import { getIsCheckedProducts } from 'common/helpers/get-is-checked-products.helper';
import { ComplementaryProduct as ComplementaryProductCommon } from 'pages/common/components/ComplementaryProduct';
import { TProductVariant } from 'pages/saved-project-configuration/types';
import { savedConfigurationCalculationState } from '../../store/calculation';
import { addNewCountValue } from './helpers/add-new-count-value';
import { ComplementaryGroupVariants } from './components/ComplementaryGroupVariants';
import { Checkbox } from './components/Checkbox';
import { ComplimentaryProductInfoBlock } from './styles';

type TProps = {
  photo?: string;
  displayedName?: string;
  productId: string;
  count: number;
  price: number;
  productPageName?: string;
  productVariants?: TProductVariant[];
  groupName?: string;
};

export const ComplementaryProduct = ({
  photo,
  displayedName = '',
  productId,
  count,
  price,
  productPageName,
  productVariants,
  groupName,
}: TProps) => {
  const [savedConfigurationCalculation, setSavedConfigurationCalculation] = useRecoilState(
    savedConfigurationCalculationState
  );
  const handleChangeCounter = (_: ChangeEvent<HTMLInputElement>, value: string) => {
    const newQuantity = Number(value);

    setSavedConfigurationCalculation(prevState =>
      addNewCountValue({ prevState, newValue: newQuantity, productId })
    );
  };

  const isDisable = !getIsCheckedProducts({
    checkedProducts: savedConfigurationCalculation.checkedProducts,
    productId: productId ?? '',
  });

  const hasVariants = !!productVariants && productVariants.length > 1 && !!groupName;

  return (
    <ComplimentaryProductInfoBlock data-testid="complimentary-product">
      <ComplementaryProductCommon
        photo={photo}
        displayedName={displayedName}
        productId={productId}
        count={count}
        price={price}
        productPageName={productPageName}
        isDisabled={isDisable}
        onChangeCounter={handleChangeCounter}
        checkboxComponent={<Checkbox productId={productId ?? ''} />}
        variantsComponent={
          hasVariants ? (
            <ComplementaryGroupVariants
              variants={productVariants}
              productId={productId}
              groupName={groupName}
            />
          ) : null
        }
      />
    </ComplimentaryProductInfoBlock>
  );
};
